@if (content.titleTranslationLabel) {
  <div class="modal-header">
    <h4 class="modal-title">
      {{ content.titleTranslationLabel | translate }}
    </h4>
  </div>
}

<div class="modal-body">
  <p [innerHTML]="content.messageTranslationLabel | translate"></p>
</div>

<div class="modal-footer d-flex justify-content-end">
  <button type="button" class="btn btn-primary" (click)="activeModal.close(true)">
    {{ 'buttons.ok' | translate }}
  </button>
</div>
